import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import ErrorBoundary from '@surfline/quiver-react/dist/ErrorBoundary';
import { hot } from 'react-hot-loader';
import initializeAnonymousId from '../../utils/initializeAnonymousId';
import { Upgrade, NotFound } from '../../containers';

class App extends Component {
  constructor(props) {
    super(props);
    const {
      identity
    } = props;
    initializeAnonymousId(identity, 'upgrade');
  }

  render() {
    return (
      <ErrorBoundary>
        <div className="upgrade-container">
          <Switch>
            <Route exact path="/upgrade" component={Upgrade} />
            <Route path="*" component={NotFound} status={404} />
          </Switch>
        </div>
      </ErrorBoundary>
    );
  }
}

export default hot(module)(App);
